import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_ACTION_RENDERED, ANALYTICS_SUBJECT_TILES, UI_EVENT_TYPE } from '@atlassian/mpac-analytics';
import { certificationBadgeResolver, isEcosystemCloudApp } from '../../common/utils/hitsStatsHelper';
const ANALYTICS_SUBJECT_ID_RECOMMENDATION_TILES = 'recommendationTiles';
const EVENT_CHANNEL = 'addonDiscovery';
const OBJECT_TYPE_APP = 'app';
const TilesRenderedEvent = {
  action: ANALYTICS_ACTION_RENDERED,
  actionSubject: ANALYTICS_SUBJECT_TILES,
  details: 'Marketplace recommendation app tiles were rendered and are now visible to the user',
  type: UI_EVENT_TYPE
};
const handleAnalyticsEvent = fireAnalyticsEvent => (actionSubjectId, attributes) => {
  fireAnalyticsEvent({
    eventType: TilesRenderedEvent,
    objectType: OBJECT_TYPE_APP,
    actionSubjectId,
    attributes: _objectSpread({}, attributes)
  }, EVENT_CHANNEL);
};
export const trackTileRenders = props => {
  const recommendationsData = props.recommendationsResult.hits;
  const fireEvent = handleAnalyticsEvent(props.fireAnalyticsEvent);
  if (recommendationsData && recommendationsData.size) {
    const ecosystemCloudAppTiles = recommendationsData.filter(isEcosystemCloudApp);
    const ecosystemCloudAppKeys = ecosystemCloudAppTiles.map(tile => ({
      key: tile.addonKey,
      isEcosystemCloudApp: true
    }));
    const {
      hasCloudFortifiedBadge,
      hasCloudSecurityBadge
    } = certificationBadgeResolver();
    fireEvent(ANALYTICS_SUBJECT_ID_RECOMMENDATION_TILES, {
      totalTiles: recommendationsData.size,
      totalTilesWithCloudSecurityBadge: recommendationsData.filter(hasCloudSecurityBadge).size,
      totalTilesWithCloudFortifiedBadge: recommendationsData.filter(hasCloudFortifiedBadge).size,
      appKeys: ecosystemCloudAppKeys,
      totalEcosystemCloudAppTiles: ecosystemCloudAppTiles.size,
      hitsType: props.recommendationsResult.hitsType
    });
  }
};